import { z, ZodIssueCode } from 'zod';

import i18n from '@/i18n';

// Zod default poruke (npr. "String must contain at least 1 character(s)") su
// hardkodirane na engleskom i ne prolaze kroz i18n. Ovaj globalni error map
// presreće samo slučajeve koji se stvarno koriste u formama (required, min
// duljina, email format) i prevodi ih preko postojećih translation.json
// datoteka — svaka nova forma automatski dobiva prevedene poruke, bez da
// svaka schema/render mjesto to mora ručno raditi. Custom .refine() poruke
// (npr. "passwordsMustMatch") prolaze kroz ctx.defaultError nepromijenjene —
// te se prevode ručno na mjestu prikaza, kao i do sada.
z.setErrorMap((issue, ctx) => {
  // Polje bez initialValues ulazi u validaciju kao undefined — Zod tad baca
  // invalid_type ("Required"), ne too_small, prije nego korisnik uopće štogod upiše.
  if (issue.code === ZodIssueCode.invalid_type && issue.received === 'undefined') {
    return { message: i18n.t('validation.required') };
  }

  if (issue.code === ZodIssueCode.invalid_string && issue.validation === 'email') {
    return { message: i18n.t('validation.invalidEmail') };
  }

  if (issue.code === ZodIssueCode.too_small && issue.type === 'string') {
    return {
      message:
        issue.minimum === 1
          ? i18n.t('validation.required')
          : i18n.t('validation.minLength', { count: issue.minimum })
    };
  }

  // .positive() na brojevima baca too_small s minimum: 0, inclusive: false —
  // najčešći slučaj (jedinična cijena, itd.), zato posebna poruka umjesto
  // generičkog "mora biti veće od {{min}}".
  if (issue.code === ZodIssueCode.too_small && issue.type === 'number') {
    return {
      message:
        issue.minimum === 0 && !issue.inclusive
          ? i18n.t('validation.mustBePositive')
          : i18n.t('validation.numberMin', { min: issue.minimum })
    };
  }

  return { message: ctx.defaultError };
});
